import { RootState } from '../store';

import { ITransactionsHistoryState } from './transactionsHistory.slice';

export const selectTransactionsHistory = (state: RootState) => state.transactionsHistory.transactionsHistory;
export const selectRecentTransactionId = (state: RootState) => state.transactionsHistory.recentTransactionId;
export const selectTransactionsHistoryState = (state: RootState): ITransactionsHistoryState => state.transactionsHistory;
